export default function observe(node: HTMLElement, observer: ResizeObserver | IntersectionObserver | undefined) {
  if (observer) {
    observer.observe(node);
    return {
      destroy: () => observer.unobserve(node),
    };
  }
}
